import { useState, useEffect } from 'react';
import {getSalesReps} from "../../services/Administrative/usersService";

export const useGetSalesRep = () => {
    const [salesReps, setSalesReps] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchSalesReps = async () => {
            setIsLoading(true);
            try {
                const response: any = await getSalesReps();
                setSalesReps(response);
            } catch (error:any) {
                console.log(error);
            } finally {
                setTimeout(() => {setIsLoading(false)}, 600)
            }
        };
        fetchSalesReps();
    }, []);

    return { salesReps, isLoading };
};
